import { Tag, Typography } from 'antd';
import { personaLabelFromModule } from '@/utils/aiPageContextFromPath';

const { Text } = Typography;

/**
 * Heuristic “persona” from current module (matches backend `routePersona` feel).
 */
export function PersonaBadge({ module }: { module?: string }) {
  const label = personaLabelFromModule(module);
  return (
    <div>
      <Text type="secondary" style={{ fontSize: 12, marginRight: 6 }}>
        Persona
      </Text>
      <Tag color="geekblue">{label}</Tag>
    </div>
  );
}
